module.exports = __webpack_public_path__ + "media/components/country-flag/static/za-2431ee598ac1cb1f538d68cc350ef435.svg";